import { Button, Card, CardContent, CardHeader, Grid, Paper } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { OrdersDash } from '../components/dashboard/OrdersDash';
import { LinksDash } from '../components/dashboard/LinksDash';
import { LCCDash } from '../components/dashboard/LCCDash';

const Home = () => {
    const user = useSelector(state => state.auth.user)
    if(user) {
        if(user.rep_id) {
            return <Navigate to="/commissions/" />
        }
    } else {
        return <></>
    }

    let lcc_functions = (process.env.REACT_APP_PREFIX.includes("lcc")) ?
    <Grid item><LCCDash /></Grid>
    : <></>;

    return <Grid container alignItems={"top"} spacing={2} justifyContent={"center"} sx={{marginTop: 2}}>
            <Grid item><OrdersDash /></Grid>
            <Grid item><LinksDash /></Grid>
            <Grid item><Paper><Card><CardHeader title="Shipping Settings" titleTypographyProps={{variant: "h2"}} subheader="" /><CardContent><Button variant="contained" component={RouterLink} to={`/shippingsettings/`}>Edit Settings</Button></CardContent></Card></Paper></Grid>
            {lcc_functions}
        </Grid>
}

export default Home;
